import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/shared.service';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { ParentDelaerService } from './parent-delaer.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-parent-dealer',
  templateUrl: './parent-dealer.component.html',
  styleUrls: ['./parent-dealer.component.scss']
})
export class ParentDealerComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  displayedColumns: string[] = ['SNo', 'dealer_name', 'dealer_code', 'zone', 'state', 'region', 'district', 'area', 'location', 'status', 'action'];
  verificationDisplayedColumns: string[] = [
    'SNo',
    'username',
    'ip_address',
    'createdAt'
  ];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  verificationDataSource = new MatTableDataSource(this.ELEMENT_DATA);

  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  dealerForm: FormGroup;
  isLoading: Subject<boolean> = new Subject<boolean>();
  public searchInput = new FormControl("");
  public statusFilter = new FormControl("All");
  public parentDealerList: any[] = [];

  constructor(private router: Router, private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private dealerService: ParentDelaerService) {
    this.dealerForm = this.fb.group({
      dealerName: ['', Validators.required],
      dealerCode: ['', Validators.required],
      parent_dealer_map_code: ['', Validators.required],
      location_code: ['', Validators.required],
      country: ['', Validators.required],
      zone: ['', Validators.required],
      state: ['', Validators.required],
      region: ['', Validators.required],
      district: [''],
      area: [''],
      location: [''],
      status: ['', Validators.required],
      is_verified: [false],
    });
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;
  public isParentDealerVerification: boolean = false;

  ngOnInit() {
    this.getList();
    this.getCountryList();
    this.searchInput.valueChanges.subscribe(() => {
      this.applyFilter();
    });
    this.statusFilter.valueChanges.subscribe(() => {
      this.applyFilter();
    });
  }

  get f() { return this.dealerForm.controls; }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    this.getZoneList(object?.country?.id);
    this.getStateList(object?.zone?.id);
    this.getRegionList(object?.state?.id);
    this.getDistrictList(object?.region?.id);
    if (object?.district) {
      this.getAreaList(object?.district?.id);
    }
    if (object?.area) {
      this.getLocationList(object?.area?.id);
    }
    this.dealerForm.patchValue({
      dealerName: object.dealer_name,
      dealerCode: object.dealer_code,
      parent_dealer_map_code: object.parent_dealer_map_code,
      location_code: object.location_code,
      country: object?.country?.id,
      zone: object.zone.id,
      state: object.state.id,
      region: object.region.id,
      district: object.district?.id ? object.district?.id : "",
      area: object.area?.id ? object.area?.id : "",
      location: object.location?.id ? object.location?.id : "",
      status: object.status ? 1 : 0,
      is_verified: object.is_verified_by_user
    })
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.isParentDealerVerification = false;
    this.getList();
  }

  // applyFilter() {
  //   const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';

  //   this.dataSource.filterPredicate = (data: any, filter: string) => {
  //     const dealer = data.dealer_name.toLowerCase().includes(filter);
  //     const dealerCodeMatch = data.dealer_code.toLowerCase().includes(filter);
  //     return dealer || dealerCodeMatch;
  //   };
  //   this.dataSource.filter = filterValue;
  // }

  applyFilter() {
    let filteredData = this.parentDealerList || [];

    // Filter by dropdown status selection
    const statusVal = this.statusFilter.value;
    if (statusVal == '1') {
      filteredData = filteredData.filter((data: any) => data.alert_flag == 1);
    } else if (statusVal == '2') {
      filteredData = filteredData.filter((data: any) => data.alert_flag == 2);
    } else if (statusVal == '3') {
      filteredData = filteredData.filter((data: any) => data.alert_flag == 3);
    }

    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
    if (filterValue) {
      filteredData = filteredData.filter((data: any) => {
        const dealer = data.dealer_name ? data.dealer_name.toLowerCase().includes(filterValue) : false;
        const dealerCodeMatch = data.dealer_code ? data.dealer_code.toLowerCase().includes(filterValue) : false;
        const dealerMapCodeMatch = data.parent_dealer_map_code ? data.parent_dealer_map_code.toLowerCase().includes(filterValue) : false;
        return dealer || dealerCodeMatch || dealerMapCodeMatch;
      });
    }

    this.dataSource.data = filteredData;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  clearSearch() {
    this.searchInput.setValue(''); // Clear the search input
    this.applyFilter();
  }

  create() {
    this.submitted = true

    if (this.dealerForm.valid) {
      const locationData = this.dealerForm.value;
      let obj = {
        "dealer_name": locationData.dealerName,
        "dealer_code": locationData.dealerCode,
        "parent_dealer_map_code": locationData.parent_dealer_map_code ? locationData.parent_dealer_map_code : null,
        "location_code": locationData.location_code ? locationData.location_code : null,
        "country_id": locationData.country,
        "zone_id": locationData.zone,
        "region_id": locationData.region,
        "state_id": locationData.state,
        "district_id": locationData.district ? locationData.district : null,
        "area_id": locationData.area ? locationData.area : null,
        "location_id": locationData.location ? locationData.location : null,
        "status": parseInt(locationData.status)
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.dealerService.createDealer(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Parent dealer created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    this.submitted = true
    Object.keys(this.dealerForm.controls).forEach(key => {
      const control = this.dealerForm.get(key);

      if (control?.invalid) {
        console.log(key, control.errors);
      }
    });
    console.log(this.dealerForm.valid, 'locationData');
    if (this.dealerForm.valid) {
      const locationData = this.dealerForm.value;


      let obj = {
        "dealer_name": locationData.dealerName,
        "dealer_code": locationData.dealerCode,
        "parent_dealer_map_code": locationData.parent_dealer_map_code ? locationData.parent_dealer_map_code : null,
        "location_code": locationData.location_code ? locationData.location_code : null,
        "country_id": locationData.country,
        "zone_id": locationData.zone,
        "region_id": locationData.region,
        "state_id": locationData.state,
        "district_id": locationData.district,
        "area_id": locationData.area,
        "location_id": locationData.location,
        "status": parseInt(locationData.status),
        "is_verified": locationData.is_verified,
      }

      this.isLoading = new BehaviorSubject<boolean>(true);
      this.dealerService.updateDealer(obj, this.selectedObject.id).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Parent dealer updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    this.dealerForm.patchValue({
      dealerName: '',
      dealerCode: '',
      parent_dealer_map_code: '',
      location_code: '',
      country: '',
      zone: '',
      state: '',
      region: '',
      district: '',
      area: '',
      location: '',
      status: '',
      is_verified: '',
    });
    this.zoneList = [];
    this.stateList = [];
    this.regionList = [];
    this.districtList = [];
    this.areaList = [];
    this.locationList = [];

  }

  allowNumbersHyphenOnly(event: any) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[0-9\-]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  getList() {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.dealerService.getParentDealer().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data;
        this.parentDealerList = responseData.data;
        this.dataSource = new MatTableDataSource(this.parentDealerList);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.applyFilter();
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }

    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  countryList: any = []
  getCountryList() {
    this.dealerService.getCountry().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.countryList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  stateList: any = []
  getStateList(zoneId?: any) {
    this.stateList = []
    this.regionList = [];
    this.districtList = [];
    this.areaList = [];
    this.locationList = []
    this.dealerForm.patchValue({ state: '', region: "", district: '', area: '', location: '' })
    let id: any = this.dealerForm.value.zone ? this.dealerForm.value.zone : zoneId;
    this.dealerService.getStateByZone(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.stateList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  zoneList: any = []
  getZoneList(countryId?: any) {
    this.zoneList = []
    this.dealerForm.patchValue({ zone: '' })
    let id: any = this.dealerForm.value.country ? this.dealerForm.value.country : countryId
    this.dealerService.getZoneByCountry(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.zoneList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  regionList: any = []
  getRegionList(stateId?: any) {
    this.regionList = []
    this.districtList = [];
    this.areaList = [];
    this.locationList = []
    this.dealerForm.patchValue({ region: "", district: '', area: '', location: '' })
    let id: any = this.dealerForm.value.state ? this.dealerForm.value.state : stateId;
    this.dealerService.getRegionByState(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.regionList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  districtList: any = []
  getDistrictList(regionId?: any) {
    this.districtList = []
    this.areaList = [];
    this.locationList = []
    this.dealerForm.patchValue({ district: '', area: '', location: '' })
    let id: any = this.dealerForm.value.region ? this.dealerForm.value.region : regionId;
    this.dealerService.getDistrictByRegion(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.districtList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  areaList: any = []
  getAreaList(districtId?: any) {
    this.areaList = []
    this.locationList = []
    this.dealerForm.patchValue({ area: '', location: '' })
    let id: any = this.dealerForm.value.district ? this.dealerForm.value.district : districtId;
    this.dealerService.getAreaByDistrict(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.areaList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  locationList: any = []
  getLocationList(areaId?: any) {
    this.locationList = []
    this.dealerForm.patchValue({ location: '' })
    let id: any = this.dealerForm.value.area ? this.dealerForm.value.area : areaId;
    this.dealerService.getLocationByArea(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.locationList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  export() {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.dealerService.getExport().subscribe({
      next: (res: any) => {
        if (res.body.responseCode == 200) {
          const url = res.body.data.download_url;
          const link = document.createElement('a');
          link.href = url;
          link.download = 'FILENAME'; // Optional: specify the filename
          link.click();
          this.toastr.success(res.body.responseMessage);
        } else {
          this.toastr.error(res.body.responseMessage);
        }
      }, error: (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
      },
      complete: () => {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    });
  }

  goToImport() {
    this.router.navigateByUrl('/suzuki/import', { state: { page: { name: 'dealer' } } });
  }

  viewUserData(parentDealerData?: any) {
    this.isLoading.next(true);

    //this.isOutletVerification = true;
    this.dealerService.getUserList(parentDealerData?.id, 'Dealer').subscribe({
      next: (response: any) => {
        const responseData = response.body;
        console.log("responseData", responseData);
        if (responseData.responseCode === 200) {
          this.isLoading.next(false);

          const verificationRows: any[] = [];

          responseData.data.forEach((parentDealer: any) => {
            parentDealer.dealerVerifications?.forEach((verification: any) => {
              verificationRows.push({
                username: verification.user?.username,
                createdAt: verification.createdAt,
                ip_address: verification.ip_address,
              });
            });
          });

          this.ELEMENT_DATA = verificationRows;
          this.verificationDataSource = this.ELEMENT_DATA;
          console.log("this.ELEMENT_DATA", this.ELEMENT_DATA);

          this.verificationDataSource.sort = this.sort;
          // this.verificationDataSource.paginator = this.verificationPaginator;

          // Show verification view
          this.isCreate = false;
          this.isEdit = false;
          this.isParentDealerVerification = true;
        } else {
          this.isLoading.next(false);
        }
      },
      error: () => {
        this.isLoading.next(false);
      }
    });
  }
}
